import account from './account';
import diagram from './diagram';
import document from './document';
import followUps from './followUps';
import magview from './magview';
import outsideStudy from './outsideStudy';
import patient from './patient';
import refPhy from './refPhy';
import study from './study';
import worklist from './worklist';
import worklistFilterSettings from './worklistFilterSettings';
import lookups from './lookups';
import SurveyService from './survey';
import config from './config';
import WorklistUserSettings from "./worklistUserSettings";




// WEBPACK FOOTER //
// ./src/scripts/domains/index.js